import type { KYCQuestionnaireElement } from '@anchorage/graphql/generated';

import type { NavigationItem } from '../components/NavigationMenu/NavigationMenu';

const getNavElements = (elements: KYCQuestionnaireElement[]) =>
  elements.filter(({ type }) => type === 'NAV');

export const getNavigationItems = ({
  elements = [],
  setCurrentPageId,
}: {
  elements?: KYCQuestionnaireElement[];
  setCurrentPageId: (id: string) => void;
}) => {
  const navigationItems: NavigationItem[] = [];

  elements.forEach((navElement) => {
    const mainNavElement: NavigationItem = {
      id: navElement.id,
      title: navElement.title,
      onClick: () => setCurrentPageId(navElement.id),
      icon: navElement.layout?.icon,
    };

    const subNavElements = getNavElements(navElement?.elements).map(
      (subNavElement) => ({
        id: subNavElement.id,
        title: subNavElement.title,
        onClick: () => setCurrentPageId(subNavElement.id),
        icon: navElement.layout?.icon,
      }),
    );
    if (subNavElements.length) {
      mainNavElement.elements = subNavElements;
      mainNavElement.onClick = () =>
        setCurrentPageId(subNavElements[0]?.id ?? navElement.id);
    }

    navigationItems.push(mainNavElement);
  });

  return navigationItems;
};
